import { useEffect, useState, useRef } from "react";
import WebMercatorViewport from "viewport-mercator-project";

import { isRunTime } from "../../utils/isRunTime";
import { getLatitude, getLongitude } from "src/utils/location";

const useMap = (suppliers, mapPadding, subField, selectedLodging) => {
  const [viewport, setViewport] = useState({
    width:
      isRunTime() &&
      document.getElementsByClassName("mapboxgl-map")[0]?.clientWidth,
    height:
      isRunTime() &&
      document.getElementsByClassName("mapboxgl-map")[0]?.clientHeight,
  });
  const [renderMap, setRenderMap] = useState(false);
  const [points, setPoints] = useState([]);
  const [isDown, setIsDown] = useState(false);
  const slider = useRef(null);
  let startX;
  let scrollLeft;

  useEffect(() => {
    setTimeout(() => {
      setRenderMap(true)
    }, 5000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (viewport.width && viewport.height && suppliers) {
      updateMap(suppliers);
    }
    // eslint-disable-next-line
  }, [suppliers.length, viewport.height, viewport.width]);

  const zoomToSelectedMarker = () => {
    const newViewport = {...viewport};
    const index = selectedLodging.lastIndexOf("_")
    const indexOfSupplier = selectedLodging.slice(index + 1)
    const supplierToZoom = suppliers[indexOfSupplier]
    const latitude = parseFloat( getLatitude(supplierToZoom.location) )
    const longitude = parseFloat( getLongitude(supplierToZoom.location) )
    const WBViewport = new WebMercatorViewport({
      width: viewport.width,
      height: viewport.height,
    });

    const corners =[[longitude,latitude], [longitude, latitude]]
    const bound = WBViewport.fitBounds(corners, {
      padding: mapPadding
        ? mapPadding
        : { top: 20, bottom: 30, left: 20, right: 20 },
    });
    newViewport.latitude = bound.latitude;
    newViewport.longitude = bound.longitude;
    newViewport.zoom = 17;
    setViewport(newViewport)
  }

  useEffect(() => {
    if(selectedLodging) zoomToSelectedMarker();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLodging]);

  const updateMap = (markers, newViewport = viewport) => {
    let arrayPoints = [];
    let bottomLeft = [undefined, undefined];
    let topRight = [undefined, undefined];

    markers.forEach((marker, index) => {
      let latitude = getLatitude(marker);
      let longitude = getLongitude(marker);
      if (subField) {
        latitude = getLatitude(marker[subField]);
        longitude = getLongitude(marker[subField]);
      }
      if (typeof latitude === "string") latitude = parseFloat(latitude.replace(',', '.').replace(/[^\d.-]/g, ''));
      if (typeof longitude === "string") longitude = parseFloat(longitude.replace(',', '.').replace(/[^\d.-]/g, ''));
      if (
        latitude !== null &&
        latitude !== 0 &&
        latitude < 90 &&
        latitude > -90
      ) {
        if (latitude < bottomLeft[1] || bottomLeft[1] === undefined) {
          bottomLeft[1] = latitude;
        }
        if (latitude > topRight[1] || topRight[1] === undefined) {
          topRight[1] = latitude;
        }
        if (longitude < bottomLeft[0] || bottomLeft[0] === undefined) {
          bottomLeft[0] = longitude;
        }
        if (longitude > topRight[0] || topRight[0] === undefined) {
          topRight[0] = longitude;
        }

        marker.index = index;
        arrayPoints.push({ ...marker, latitude, longitude });
      }
    });
    if (arrayPoints.length > 1) {
      let corners = [bottomLeft, topRight];
      const WBViewport = new WebMercatorViewport({
        width: viewport.width,
        height: viewport.height,
      });
      const bound = WBViewport.fitBounds(corners, {
        padding: mapPadding
          ? mapPadding
          : { top: 20, bottom: 30, left: 20, right: 20 },
      });
      newViewport.latitude = bound.latitude;
      newViewport.longitude = bound.longitude;
      newViewport.zoom = bound.zoom - 1;
    } else if (suppliers.length > 0) {
      let latitude = getLatitude(suppliers[0]);
      let longitude = getLongitude(suppliers[0]);
      if (subField === "location") {
        // Use helper functions to get coordinates regardless of location source
        latitude = getLatitude(suppliers[0].location);
        longitude = getLongitude(suppliers[0].location);
      } else if (subField) {
        const coords = suppliers[0][subField];
        latitude = getLatitude(coords);
        longitude = getLongitude(coords);
      }
      if (typeof latitude === "string") latitude = parseFloat(latitude.replace(',', '.').replace(/[^\d.-]/g, ''));
      if (typeof longitude === "string") longitude = parseFloat(longitude.replace(',', '.').replace(/[^\d.-]/g, ''));
      newViewport.latitude = latitude;
      newViewport.longitude = longitude;
      newViewport.zoom = 13;
    }

    setViewport(newViewport);
    setPoints(arrayPoints);
  };

  const sliderOnMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setIsDown(true);
    slider.current.classList.add("active");
    startX = e.pageX - slider.current.offsetLeft;
    scrollLeft = slider.current.scrollLeft;
  };

  const sliderOnMouseUp = () => {
    setIsDown(false);
    slider.current.classList.remove("active");
  };

  const sliderOnMouseMove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (!isDown) return;
    const x = e.pageX - slider.current.offsetLeft;
    const walk = (x - startX) * 3;
    slider.current.scrollLeft = scrollLeft - walk;
  };

  return {
    renderMap,
    points,
    viewport,
    selectedLodging,
    slider,
    setViewport,
    sliderOnMouseDown,
    sliderOnMouseMove,
    sliderOnMouseUp,
  };
};

export default useMap;
